var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B5BB5",
    fillRule: "nonzero",
    points: "43 26 3 26 0 22 4 18 42 18 46 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillRule: "nonzero",
    d: "M40,46 L6,46 C4.895,46 4,45.105 4,44 L4,2 C4,0.895 4.895,0 6,0 L30,0 L42,12 L42,44 C42,45.105 41.105,46 40,46 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    fillRule: "nonzero",
    d: "M30,0 L30,10 C30,11.105 30.895,12 32,12 L42,12 L30,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8680D8",
    fillRule: "nonzero",
    d: "M44,40 L2,40 C0.895,40 0,39.105 0,38 L0,22 L46,22 L46,38 C46,39.105 45.105,40 44,40 Z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "ProximaNova-Extrabld, Proxima Nova",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 35
  }, "KEY")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileKey);
export default __webpack_public_path__ + "static/media/icon-file-key.eb69111c3091c0793d1e0551c4b09ebf.svg";
export { ForwardRef as ReactComponent };